export default "__VITE_ASSET__hdoOd8Vs__"